import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import axiosInstance from '../utils/axiosInstance';
import DatePicker from "react-datepicker";
import * as XLSX from 'xlsx';
import "react-datepicker/dist/react-datepicker.css";
import './admin.css';


function Admin( {authenticatedUser, isAdmin} ) {  

    const getInitialCurrentUser = () => {
        const value = "0"
        return value;
    }
    const getInitialSortByState = () => {
        const value = "Date";
        return value;
    };
    const getInitialSortDirState = () => {
        const value = "DESC";
        return value;
    };

    const navigate = useNavigate();
    
    const [currentUser, setCurrentUser] = useState(getInitialCurrentUser);
    const [users, setUsers] = useState([{value: "0", label: "ALL USERS", exclusive: 1}]);

    const [selectedOptions, setSelectedOptions] = useState([users[0]]);

    const columnNames = [{value: "Date", label: "Date"}, {value: "A-Z", label: "A-Z"}, {value: "Total Refund", label: "Total Refund"}, {value: "LowPro", label: "LowPro"}];
    const [sortBy, setSortBy] = useState(getInitialSortByState);
    
    const sortOpt = [{value: "ASC", label: "ASC"}, {value: "DESC", label: "DESC"}];
    const [sortDir, setSortDir] = useState(getInitialSortDirState);

    const [start, setStart] = useState(null);
    const [end, setEnd] = useState(null);

    const [activity, setActivity] = useState([]);
    
    const [gettingResults, setGettingResults] = useState(true);

    useEffect(() => { //might have to change this to update on refresh? [] at the end?
        clearSearch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
        if (authenticatedUser === null) {
            return;
        } 

        if(authenticatedUser === false){
            //console.log('authenticatedUser is null sending to login page')
            navigate("/login");
        }
        else{
            if(isAdmin === false){
                navigate("/search");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[authenticatedUser, isAdmin]);

    useEffect(() => {
        setCurrentUser('');
        setCurrentUser( selectedOptions.map(areaObj => areaObj.value).join(",") );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOptions]);

    const customStyles = {
        control: (provided) => ({
            ...provided,
            display: 'inline-flex', // or 'inline-flex'
            width: 'auto', // Adjust as needed
            marginRight: '10px',
        }),
        option: (base) => ({ ...base, color: 'black' }),
        menu: (provided) => ({
            ...provided,
            width: 'max-content',
            minWidth: '100%',
          }),
    };

    const clearSearch = () => {
        setGettingResults(true)
        setCurrentUser(getInitialCurrentUser);
        setSortBy(getInitialSortByState);
        axiosInstance.get('/getActivity', {withCredentials:true})
        .then(response => {
            setActivity(response.data[0]);
            setUsers(users.concat(response.data[1].map( ( userObj ) => ({ value: userObj.ID, label: userObj.username, exclusive: userObj.Exclusive}) )));
            setGettingResults(false)
            //console.log(activity);
        })
        .catch(error => console.error('Error fetching activity:', error));
    };

    const getUserActivity = () => {
        if (!(start === '') !== !(end === '')) {
            console.log('Must enter value for both start and ending range')
            return
        }
        setGettingResults(true)
        axiosInstance.post('/searchActivity', {data: {id: currentUser, sortBy: sortBy, sortDir: sortDir, start: start, end: end}}, {withCredentials:true})
        .then(response => {
            setActivity(response.data[0]);
            setGettingResults(false)
        })
        .catch(error => console.error('Error fetching search activity:', error));
    };

    /*const handleUserChange = (e) => {
        setCurrentUser(e.target.value);
    };*/

    const handleUserChangeTwo = (selected, action) => {
        if (action.action === 'select-option' && selected.find(option => option.exclusive === 1)) {
            setSelectedOptions([selected.find(option => option.exclusive === 1)]);
        } else {
            setSelectedOptions(selected);
        }
        //console.log(currentUser);
    };

    const handleSortByDropDownChange = (e) => {
        setSortBy(e.target.value);
    };

    const handleSortDirDropDownChange = (e) => {
        setSortDir(e.target.value);
    }

    const clickMe = (data) => {
        navigate("/taxpayer", { state: {data: data} });
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
          getUserActivity();
        }
      };

    const exportToExcel = () => {
        const exportActivity = activity.map( ({ dateSearched, ...rest }) => ({ ...rest, ActivityDate: new Date(rest.ExportDate)  }) );
        
        var ws = XLSX.utils.json_to_sheet(exportActivity);
        /* create workbook and export */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, "SearchActivity.xlsx");
    };

    if(gettingResults){
        return <div className="admin-app"> <h1>Loading Admin Page...</h1> </div>
    }

    return (
        <div className="admin-app">
                
            <h1>Admin Page</h1>
            <p>Disclaimer: All information contained herein is proprietary to T-COT and is provided solely for the purpose of obtaining a contract with T-COT. Unauthorized use, disclosure, or distribution of this information is strictly prohibited. Any other use of this information without the express written consent of T-COT is not permitted.</p>

            <div className="admin-input">
                <p>Filter By: </p>

                <Select
                    className="user-select"
                    isClearable={false}
                    isSearchable//={false}
                    isMulti 
                    styles={customStyles}
                    controlShouldRenderValue={false}
                    hideSelectedOptions={false}
                    closeMenuOnSelect={false}
                    placeholder="Users"
                    defaultValue={users[0]}
                    options={users}
                    value={selectedOptions} //new thing here
                    onChange={handleUserChangeTwo}
                /> 

                <p>Date Range: </p>
                
                <DatePicker selected={start} onChange={(e) => setStart(e)}  dateFormat="MM/dd/yyyy"  placeholderText="MM/DD/YYYY" onKeyDown={handleKeyPress} enableTabLoop={false}/>
                <DatePicker selected={end} onChange={(e) => setEnd(e)}  dateFormat="MM/dd/yyyy"  placeholderText="MM/DD/YYYY" onKeyDown={handleKeyPress} enableTabLoop={false}/>

                <p>Sort By: </p>

                <Select
                    className="sort-select"
                    isClearable={false}
                    styles={customStyles}
                    onChange={handleSortByDropDownChange}
                    defaultValue={columnNames[0]}
                    options={columnNames} 
                />

                <Select
                    className="order-select"
                    isClearable={false}
                    styles={customStyles}
                    onChange={handleSortDirDropDownChange}
                    defaultValue={sortOpt[1]}
                    options={sortOpt} 
                /> 

                
                <button onClick={getUserActivity}>Search</button>
                
                <button onClick={clearSearch}>Clear Search</button>

                <button onClick={exportToExcel}>Export to Excel</button>

            </div>

            {activity.length === 0 && <h1>No Results Found</h1>}

            {activity.length > 0 && (
            <table id="activity-sheet" className="activity-table"> 
                <tbody>
                    <tr>
                        <th width="716.48px">TaxpayerName</th>
                        <th width="260.17px">Area</th>
                        <th width="122.34px">LowPro</th>
                        <th width="122.34px">Total Refund</th>
                        <th>Username</th>
                        <th>Date and Time</th>
                    </tr>
                    
                    {activity.map((activityObj, i) => (
                        <tr height="58px" key={i}>
                            <td>
                                <button onClick={() => clickMe({TPNumber: activityObj.TaxpayerNumber})} className="ViewDetailsBtnLink">{activityObj.TaxpayerName}</button>
                            </td>
                            <td>
                                {activityObj.Area}
                            </td>
                            <td>
                                {activityObj.LowPro}
                            </td>
                            <td>
                                {activityObj.Refund}
                            </td>
                            <td>
                                {activityObj.username}
                            </td>
                            <td>
                                {activityObj.dateSearched}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>)}

        </div>
    );
}

export default Admin;